import { Popup } from '@approvalmax/ui';
import styled from 'styled-components';

export const Root = styled(Popup.DefaultContent)`
    min-width: 640px;
    width: 900px;
    height: 650px;
`;
